import "./index.scss";
import React from "react";
import Popover from "devextreme-react/popover";
import { IMdaePopoverProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

const MdaePopover: React.FC<IMdaePopoverProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-popover-container"}>
      <Popover
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_POPOVER,
            e.component,
            dispatch
          );
        }}
      >{props.children}</Popover>
    </div>
  );
};
export default MdaePopover;
